export default __webpack_public_path__ + "static/PH-Summer-Sale-Homepage-Banner-Desktop-a609bfc3d08e86983379d0bfefe12ba1.webp";